import { FormHelperText, TextField } from "@mui/material";
import { ContactField } from "../types";
import { GENERAL_EMAIL_REGEX, getDefaultInputMaxLength, isEmpty, PHONE_REGEX, phoneMask, slugify } from "../utils";
import { useEffect, useState } from "react";
import { MaskedInput } from "./MaskedInput";

export const ContactInput = (props: ContactField & {
    group_id: string
    onUpdate: (group_id: string, name: string, value: string) => void
}) => {
    const [initialized, setInitialized] = useState<boolean>(false)
    const [dirty, setDirty] = useState<boolean>(false)
    const [timeoutID, setTimeoutID] = useState<NodeJS.Timeout>()
    const [error, setError] = useState<string | null>(null)
    const htmlID = slugify(['contact-field', props.id, props.name].join('-'))
    const hasError = error !== null && dirty
    const updateTimeout = () => {
        if (timeoutID) {
            clearTimeout(timeoutID)
        }
        setTimeoutID(setTimeout(() => {
            setError(validateInput(props))
        }, 300))
    }
    useEffect(() => {
        setInitialized(true)
    }, [])
    useEffect(() => {
        if (initialized) {
            updateTimeout()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])
    return (
        <>
            <TextField
                id={htmlID}
                type={props.type}
                name={props.name}
                label={props.label}
                value={props.value || ''}
                error={hasError}
                onChange={(event) => {
                    props.onUpdate(props.group_id, props.name, event.target.value)
                    setDirty(true)
                }}
                onBlur={() => {
                    setDirty(true)
                    updateTimeout()
                }}
                InputProps={props.type === 'phone' ? {
                    inputComponent: MaskedInput as any,
                    inputProps: phoneMask,
                } : {}}
                variant='standard'
                fullWidth
                style={hasError ? {} : { marginBottom: '1.45rem' }}
            />
            {hasError &&
                <FormHelperText
                    error
                >
                    {error}
                </FormHelperText>
            }
        </>
    )
}

export const validateInput = (props: ContactField): string | null => {
    if (isEmpty(props.value)) {
        if (props.required) {
            return 'Required'
        } else {
            return null
        }
    }
    const value = props.value!
    if (value) {
        const maxLength = !!props.maxLength ? props.maxLength : getDefaultInputMaxLength(props.type)
        if (maxLength < value.length) {
            return `Input too long. Max ${maxLength} characters`
        }
    }
    switch (props.type) {
        case 'phone':
            if (!PHONE_REGEX.test(value)) {
                return 'Not a valid phone number'
            }
            break
        case 'email':
            if (!GENERAL_EMAIL_REGEX.test(value)) {
                return 'Not a valid email address'
            }
            break
        case 'textarea':
        case 'text':
        default:
            break
    }
    return null
}
